import React from "react"
import _ from "lodash"
import { Mention, MentionsInput } from "react-mentions"
import { IUser } from "../../../features/user/state/userTypes"
import { formatUserMentionString } from "../../helpers/stringHelpers"
import { allUser } from "./MentionField"

interface IProps {
  className?: string
  textColorClass?: string
  value: string
  height?: number
  users: { [id: string]: IUser }
  isSingleLine?: boolean
}

const MentionFieldReadOnly: React.FC<IProps> = ({
  className,
  textColorClass = "text-ch-gray-600",
  value,
  users,
  isSingleLine = false
}: IProps): JSX.Element => {
  const prefixClass = "mentions-read-only"
  const defaultClasses = [prefixClass, textColorClass]
  const propClasses = className ? className.split(" ") : []
  const allClasses = [...defaultClasses, ...propClasses].join(" ")

  const renderMentionText = (id, _display): string => {
    if (id == "all") return formatUserMentionString(allUser)
    if (!users[id]) return ""
    return formatUserMentionString(users[id])
  }

  return (
    <MentionsInput
      value={value}
      className={allClasses}
      singleLine={isSingleLine}
    >
      <Mention
        className="bg-ch-blue-alt-200"
        trigger="@"
        markup="@[__display__](__id__)"
        displayTransform={(id, display) => renderMentionText(id, display)}
        data={[]}
      />
    </MentionsInput>
  )
}

export default MentionFieldReadOnly
